// Components
const ModalDeletePuppyToSell = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "modal-delete-puppy-to-sell"*/ "@/app/views/main-view/sell-your-dog/modals/delete-puppy-to-sell-modal/delete-puppy-to-sell-modal/delete-puppy-to-sell-modal.vue"
	)

// Services
import breedService from "@/app/services/main/breed/breed-service.js"
import puppySellService from "@/app/services/main/puppy-sell/puppy-sell-service.js"
import breedingManagementService from "@/app/services/main/breeding-management/breeding-management-service.js";

// Utils
import { vuelidateUtil } from "@/utils/vuelidate-util.js"

// Constants
import { STATUS_CODES, SUCCESS_MSG, ERROR_MSG, PUPPY_SELL_STATUS } from "@/app/constants/status-constants"
import { BREEDER_ROUTES } from '@/app/constants/breeder-routes-constants';

// Mixins
import { imageCompressorMixins } from "@/app/mixins/utils/image-compressor-mixins"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { dateMixins } from "@/app/mixins/utils/date-mixins"
import { inputTextMixins } from "@/app/mixins/utils/input-text-mixins"

// Third party libraries
import DatePicker from "vue2-datepicker"

export default {
	name: "SellYourDogInfoContainer",
	components: {
		DatePicker,
		ModalDeletePuppyToSell,
	},
	mixins: [imageCompressorMixins, toastMessageMixins, dateMixins, inputTextMixins],
	data() {
		return {
			PUPPY_SALES: BREEDER_ROUTES.PUPPY_SALES,
			SELL_YOUR_PUPPY_INFO: BREEDER_ROUTES.SELL_YOUR_PUPPY_INFO,
			// Date
			birthdate: null,

			// Price
			// NOTE: Removed Negotiable Price
			priceStatus: "Fixed",
			price: 0,

			// Breed List
			breedList: [],
			breedId: "",
			breedName: "",
			addedBreederId: "",
			addedBreedName: "",

			// Puppy Gender
			gender: "",
			genderOptions: [
				{
					value: "M",
					option: "Male",
				},
				{
					value: "F",
					option: "Female",
				},
			],

			// Forms
			microchipNumber: "",
			puppyName: "",
			colour: "",
			headline: "",
			body: "",

			// Puppy Status
			status: null,

			// Images
			imageRef: [],
			imageSrc: [],
			fileBlob: null,
			filesToSend: [],
			setAsPrimary: 0,
			updatedImages: [],
			deletedImages: [],

			// API Loading
			isAPILoading: false,
			isPuppyImageLoading: false,
			isNewPuppyImage: false,
			puppySellId: "",
			statusCode: "",
			isNewForm: false,
			isDuplicate: false,

			reason: "",
			isDetailsUpdated: false,
			copiedImages: [],
			copiedPublishImages: [],

			//Customer details
			buyerDetails: {},
			customerName: "",
			customerEmail: "",
			customerMobileNumber: "",
			transactionHistory: [],
			referenceNumber: "",
			puppyReferenceNumber: "",
			customerShippingAddress: "",
			showCustomerDetails: false,
			limitPrice: process.env.VUE_APP_LATITUDE_PRICE_LIMIT,
			imageTypeList: ['image/svg','image/png','image/jpg','image/jpeg','image/gif','image/raw', 'image/webp'],
			litterId: null,
			previousPage:'Breeder Details'
		}
	},
	mounted() {
		window.scrollTo( 0, 0 )
	},
	async created() {
		await this.getBreedList()
		
		if (this.$route.query.id) {
			await this.getPuppyDetails(this.$route.query.id)
		} else if (this.$route.query.litterId &&
			this.$route.query.matingId
		) {
			await this.getDamAndSireLitterDetails(this.$route.query.litterId)
			this.PUPPY_SALES = `${BREEDER_ROUTES.EDIT_LITTER}?id=${this.$route.query.matingId}&litterId=${this.$route.query.litterId}`
			this.previousPage = 'Puppy Details'
		}
		
		this.isNewForm = !this.$route.query.id
		this.checkIfToDuplicate()
	
	},
	
	watch: {
		$route() {
			this.checkIfToDuplicate();
		},
		breedName(value) {
			this.isDetailsUpdated = value != this.tmpbreedName
		},
		puppyName(value) {
			this.isDetailsUpdated = value != this.tmppuppyName
		},
		birthdate(value) {
			this.isDetailsUpdated = value != this.tmpbirthdate
		},
		price(value) {
			this.isDetailsUpdated = value != this.tmpprice
		},
		priceStatus(value) {
			this.isDetailsUpdated = value != this.tmppriceStatus
		},
		gender(value) {
			this.isDetailsUpdated = value != this.tmpgender
		},
		microchipNumber(value) {
			this.isDetailsUpdated = value != this.tmpmicrochipNumber
		},
		colour(value) {
			this.isDetailsUpdated = value != this.tmpcolour
		},
		headline(value) {
			this.isDetailsUpdated = value != this.tmpheadline
		},
		body(value) {
			this.isDetailsUpdated = value != this.tmpbody
		},
		imageSrc(value) {
			this.isDetailsUpdated = value.length != this.tmpImageSrc || this.deletedImages.length != 0
		},
		setAsPrimary(value) {
			const images = [...this.imageSrc, ...this.deletedImages]
			this.isDetailsUpdated = value != this.tmpSetAsPrimary || this.tmpImageSrc != images.length
		},
		buyerDetails(value){
			this.showCustomerDetails = Object.keys(value).length > 0;
		}
	},
	computed: {
		disablePrice() {
			return this.status != "P" && this.status != "A" && this.status != "D" && this.status != "HIDDEN"  && !this.isNewForm
		},
		enableField() {
			return this.status != "P" && this.status != "D" && this.status != "A" && this.status != "HIDDEN" && !this.isNewForm
		},
		allowUpdateOfImages() {
			return (
				(!this.isNewForm && (this.status === "P" || this.status === "A" || this.status === "D" || this.status === "HIDDEN")) ||
				this.isNewForm
			)
		},
		showUpdateButton() {
			return !this.isNewForm && (this.status === "P" || this.status === "A" || this.status === "HIDDEN")
		},
		showReApprovedButton() {
			return !this.isNewForm && this.status === "D"
		},
		showUploadButton() {
			return (
				this.imageSrc.length < 7 &&
				(this.status === "P" || this.status === "A" || this.status === "D" || this.status === "HIDDEN" || this.isNewForm)
			)
		},
		displayCustomerProcessingInfo(){
			// constant status not in sync
			return this.status === "PENDING_PAYMENT";
		},
		displayMakeAvailableButton() {
			return this.status === "HIDDEN";
		},
		selectedGender() {
			let gender = ""

			if (this.gender) {
				gender = this.gender === "M" ? "Male" : "Female"
			} else {
				gender = "Select Gender"
			}

			return gender
		},
		showEllipsis() {
			return this.status === "P" || this.status === "A"
		},

		validationRules() {
			let fields = {
				breedId: {},
				price: {},
				// NOTE: Removed Negotiable Price
				// priceStatus: {},
				birthdate: {},
				gender: {},
			}

			fields = vuelidateUtil.setRequiredValidation(fields, "breedId")
			fields = vuelidateUtil.setRequiredValidation(fields, "birthdate")
			fields = vuelidateUtil.setRequiredValidation(fields, "gender")
			fields = vuelidateUtil.setMinValueValidation(fields, "price", this.limitPrice)
			fields = vuelidateUtil.setMaxValueValidation(fields, "price", 999999.99)
			// NOTE: Removed Negotiable Price
			// fields = vuelidateUtil.setRequiredValidation(fields, "priceStatus");
			return fields
		},

		isDisabled() {
			return this.$v.$invalid || this.isAPILoading
		},

		statusDisplay() {
			return PUPPY_SELL_STATUS[this.status]
		},

		statusColor() {
			const statusMap = {
				["A"]: "status--green",
				["PICKED_UP"]: "status--green",
				["P"]: "status--blue",
				["REQUEST_REFUND"]: "status--blue",
				["S"]: "status--grey",
				["REFUNDED"]: "status--grey",
				["CANCELED"]: "status--red",
				["D"]: "status--red",
				["HIDDEN"]: "status--red",
			}

			return statusMap[this.status] || "status--grey"
		},

		charactersLeftHeadline() {
			let char = this.headline.length,
				limit = 90

			return `${limit - char} / ${limit}`
		},
		charactersLeftBody() {
			let char = this.body.length,
				limit = 500

			return `${limit - char} / ${limit}`
		},
		showPuppySellingTransactionDetails() {
			return ["A", "S", "REQUEST_REFUND", "PICKED_UP", "REFUNDED", "CANCELED", "PENDING_PAYMENT", "HIDDEN"].includes(this.status)
		},
		timelineItems() {
			let items = []

			if (this.transactionHistory) {
				for (const data of this.transactionHistory) {
					const { date, status, remarks, submittedBy } = data

					let transDate = this.formatDateTime(date)
					let content = PUPPY_SELL_STATUS[status] ? PUPPY_SELL_STATUS[status] : status

					if (status === "D" && remarks != "" && remarks) {
						content += `<br> <p class="color-warning mb-0">Declined Reason: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Verified By: ${submittedBy}</p>`
					} else if (status === "P" && remarks != "" && remarks) {
						content += `<br> <p class="color-warning mb-0">Reason: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Submitted By: ${submittedBy}</p>`
					} else if (status === "REQUEST_REFUND" && remarks != "" && remarks) {
						content += `<br> <p class="color-warning mb-0">Reason: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Submitted By: ${submittedBy}</p>`
					} else if (status === "DISAPPROVED_REFUND" && submittedBy) {
						// DISAPPROVED REFUND
						content += `<br> <p class="color-warning mb-0">Reason: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Verified By: ${submittedBy}</p>`
					} else if (status === "PENDING_PAYMENT" && remarks != "" && remarks) {
						content += `<br> <p class="color-warning mb-0">Remarks: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Submitted By: ${submittedBy}</p>`
					} else if (status === "S" && !!remarks && !!submittedBy) {
						// S - SOLD
						content += `<br> <p class="color-warning mb-0">Remarks: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Verified By: ${submittedBy}</p>`
					}  else if (status === "S" && !!remarks) {
						// S - SOLD
						content += `<br> <p class="color-warning mb-0">Remarks: ${remarks}</p>`
					} else if ((status === "A" && submittedBy) || (status === PUPPY_SELL_STATUS.HIDDEN && submittedBy)) {
						// A - Available
						content += `<br> <p class="color-warning mb-0">Remarks: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Submitted By: ${submittedBy}</p>`
					} else if (status === "CANCELED" && submittedBy) {
						// CANCELED - CANCELLED
						content += `<br> <p class="color-warning mb-0">Submitted By: ${submittedBy}</p>`
					} else if (status === "F" && submittedBy) {
						// F - FAILED
						content += `<br> <p class="color-warning mb-0">Remarks: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Verified By: ${submittedBy}</p>`
					} else if (status === "PICKED_UP" && submittedBy) {
						content += `<p class="color-warning mb-0">Verified By: ${submittedBy}</p>`
					} else if (status === "REFUNDED") {
						content += `<br> <p class="color-warning mb-0">${remarks}</p>`
						content += `<p class="color-warning mb-0">Approved By: ${submittedBy}</p>`
					} else if (submittedBy && submittedBy != "") {
						content += `<br> <p class="color-warning mb-0">Submitted By: ${submittedBy}</p>`
					}

					items.push({
						htmlMode: true,
						content: `[${transDate}] : ${content}`,
					})
				}
			}

			return items;
		},
	},
	methods: {
		checkIfToDuplicate() {
			this.isDuplicate = this.$route.query.copy === "true";
			if (this.isDuplicate) {
				this.microchipNumber = "";
				this.status = "P";
				this.isNewForm = true;
				this.imageSrc = [];
			}
		},
		// TODO: Integration with Puppy List: Get Puppy Details by ID from Puppy Lists
		async getPuppyDetails(puppySellId) {
			if (!puppySellId) {
				return
			}

			this.isAPILoading = true
			try {
				this.isAPILoading = true
				const response = await puppySellService.getPuppySellDetails(puppySellId)
				if (response.status === STATUS_CODES.SUCCESS) {
					this.setFieldsData(response.data)
					this.isAPILoading = false
				} else {
					this.showAPIErrorToast(response.data.errors[0].message, response)
					this.isAPILoading = false
				}
			} catch (err) {
				// Catch any error
				this.showGenericErrorToast()
				this.isAPILoading = false
			}
		},

		async getDamAndSireLitterDetails(litterId) {
			if (!litterId) {
				return
			}

			this.isAPILoading = true
			try {
				this.isAPILoading = true
				const response = await breedingManagementService.getDamAndSireLitterDetails(litterId);
				if (response.status === STATUS_CODES.SUCCESS) {
					this.litterId = litterId;
					this.setRelatedFieldsData(response.data)
					this.isAPILoading = false
				} else {
					this.showAPIErrorToast(response.data.errors[0].message, response)
					this.isAPILoading = false
				}
			} catch (err) {
				// Catch any error
				this.showGenericErrorToast()
				this.isAPILoading = false
			}
		},

		setRelatedFieldsData(data) {
			// const { buyerDetails, transactionHistory } = data
			const dt = data
			
			// this.puppySellId = dt.id
			this.breedId = dt.breedId
			this.breedName = dt.breedName
			this.birthdate = dt.dateOfBirth ? this.formatDate(dt.dateOfBirth) : null
			this.gender = dt.gender ? dt.gender.substring(0, 1) : null
			// this.colour = dt.collarColour
			this.imageSrc = dt.images.reverse()
			this.puppyName = dt.puppyName
			this.microchipNumber = dt.microchipNumber
			this.copiedPublishImages = dt.images

			//Select the primary image
			dt.images.forEach((img, i) => {
				if (img.primary) {
					this.setAsPrimary = i
				}
			})

			this.isPuppyImageLoading = false
		},

		setFieldsData(data) {
			const { buyerDetails, transactionHistory } = data
			const dt = data.puppyDetails

			this.puppySellId = dt.id
			this.breedId = dt.breedId
			this.breedName = dt.breedName
			this.birthdate = this.formatDate(dt.birthdate)
			this.price = dt.price
			this.priceStatus = dt.priceStatus
			this.gender = dt.gender
			this.microchipNumber = dt.microchipNumber
			this.colour = dt.colour
			this.headline = dt.headline
			this.body = dt.body
			this.status = dt.status
			this.statusCode = dt.status
			this.imageSrc = dt.images.reverse()
			this.reason = dt.reason
			this.puppyName = dt.puppyName
			this.puppyReferenceNumber = dt.puppyReferenceNumber
			// this.copiedImages = dt.images;

			//Set Temp data
			this.tmpbreedName = dt.breedName
			this.tmpbirthdate = this.formatDate(dt.birthdate)
			this.tmpprice = dt.price
			this.tmppriceStatus = dt.priceStatus
			this.tmpgender = dt.gender
			this.tmpmicrochipNumber = dt.microchipNumber
			this.tmpcolour = dt.colour
			this.tmpheadline = dt.headline
			this.tmpbody = dt.body
			this.tmppuppyName = dt.puppyName
			this.tmpImageSrc = dt.images.length

			//Select the primary image
			dt.images.forEach((img, i) => {
				if (img.primary) {
					this.setAsPrimary = i
				}
			})
			this.tmpSetAsPrimary = this.setAsPrimary

			this.transactionHistory = transactionHistory;

			// if (buyerDetails) {
			// 	this.referenceNumber = buyerDetails.referenceNumber
			// 	this.customerName = buyerDetails.recipientName
			// 	this.customerEmail = buyerDetails.email
			// 	this.customerMobileNumber = buyerDetails.mobileNumber
			// 	this.customerShippingAddress = buyerDetails.shippingAddress.address
				
				this.buyerDetails = buyerDetails;
			// }
			// else{
			// 	this.buyerDetails = {};
			// 	this.referenceNumber = "";
			// }
			
			this.isPuppyImageLoading = false
		},

		async submit() {
			this.isAPILoading = true

			const breederDetails = this.$store.getters.getBreederDetails;

			// Set Puppy Details
			const puppyDetails = {
				formData: {
					breedId: this.breedId,
					microchipNumber: this.microchipNumber,
					price: this.price,
					priceStatus: this.priceStatus,
					birthdate: this.birthdate,
					gender: this.gender,
					colour: this.colour,
					headline: this.headline,
					body: this.body,
					puppyName: this.puppyName,
					imageRef: this.imageRef,
					copiedImages: this.copiedImages.filter((dt) => dt.id),
					copiedPublishImages: this.copiedPublishImages.filter((dt) => dt.id),
					breederSysId: breederDetails.breederSysId,
					litterId: this.litterId
				},
				images: this.filesToSend.length ? this.filesToSend : [],
			}

			// Call API to save Puppy Details
			const response = await puppySellService.savePuppyDetails(puppyDetails)

			// Show Response Toast Message
			if (response.status === STATUS_CODES.SUCCESS) {
				const { SUCESS_SAVE_PUPPY_DETAILS } = this.toastMessages.puppySell()
				this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCESS_SAVE_PUPPY_DETAILS)
				this.isAPILoading = false
				this.$router.push(`${BREEDER_ROUTES.PUPPY_SALES}`)
			} else {
				// Call Error Toast
				this.showAPIErrorToast(ERROR_MSG.INTERNAL_ERROR, response)
				this.isAPILoading = false
			}
		},

		// Breeder List
		getBreedList() {
			breedService.getBreeds().then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					this.breedList = res.data.data.filter((dt) => dt.id != 0)
					this.$store.commit("setBreedLists", this.breedList)
				} else {
					const { ERROR_GET_BREED_LIST } = this.toastMessages.breed()
					this.showAPIErrorToast(ERROR_GET_BREED_LIST, res)
				}
			})
		},

		setSelected(e) {
			if (!e) {
				// To trigger the validation
				this.$v.breedId.$touch()
				this.breedId = ""
				return
			}

			let selectedId = e

			// If add breed we will check the inputted name if existing in current breed list
			if (!parseInt(e)) {
				const breed = e.split("-")
				const breedName = breed[1]
				const inCurrentBreed = this.breedList.find((item) => {
					return item.name.toLowerCase() === breedName.toLowerCase()
				})
				if (inCurrentBreed) {
					selectedId = inCurrentBreed.id
				} else {
					selectedId = parseInt(breed[0])
				}
				this.breedName = breedName
			}
			this.breedId = selectedId
		},

		onBreedBlur() {
			this.$v.breedId.$touch()
		},

		checkOptionID(option) {
			if (typeof option.id === "string") {
				return option.id ? option.id.substring(0, 2) : false
			}

			return false
		},

		createOptionBreed(breed) {
			this.addedBreedName = breed
			return { name: breed, id: `0-${breed}` }
		},

		// Gender
		onSelectedGender(gender) {
			this.gender = gender.value
		},

		// Price Validations
		allowOnlyNumbers(e) {
			const invalidChars = ["-", "+", "e", "E"]
			if (invalidChars.includes(e.key)) {
				e.preventDefault()
			}
		},

		formatNumberField(field) {
			// NOTE: Removed Negotiable Price
			// this.$v.priceStatus.$touch();

			const number = parseFloat(this[field]).toFixed(2)

			if (field < 0) {
				this[field] = 0
			} else {
				this[field] = isNaN(number) ? parseFloat("0").toFixed(2) : number
			}
		},

		// Date Picker
		beforeToday(date) {
			return date > new Date()
		},

		// Image
		async onUploadImage(event) {
			this.isNewPuppyImage = true
			// Change Object of images to Array
			const images = Object.values(event.target.files)

			this.fileBlob = images

			// Throw Error when uploaded images is more than 7
			if (images.length > 7 || this.imageSrc.length > 7 || this.imageSrc.length + images.length > 7) {
				this.showCustomErrorToast("Error", "Unable to upload more than 7 images.")
				return
			}
			
			this.fileBlob.forEach(async (file, idx) => {
				let valid  = await this.validateImageWithType(file, this.imageTypeList);
				if ( valid ) {
					let compressFile = await this.compressImage(file)
					let reader = new FileReader()
					reader.readAsDataURL(compressFile)
	
					let primary = false
					if (this.isNewForm && !this.isDuplicate) {
						if (this.filesToSend.length === 0 && idx === 0) {
							primary = true
						}
					} else {
						if (this.imageSrc.length === 0 && idx === 0) {
							primary = true
						}
					}
	
					reader.onload = async () => {
						// Push images to an array and display with imageSrc
						if (this.imageSrc.length <= 7) {
							await this.imageSrc.push(reader.result)
							await this.filesToSend.push(compressFile)
							await this.imageRef.push({ primary, name: compressFile.name })
						} else {
							return
						}
					}
				}
			})
		},

		removeImage(index, image) {
			this.isNewPuppyImage = true
			this.imageSrc.splice(index, 1)
			let isPrimaryImageDeleted = false

			if (parseInt(this.setAsPrimary) < 0) {
				this.setAsPrimary = 0
			} else if (parseInt(this.setAsPrimary) > parseInt(index)) {
				this.setAsPrimary = this.setAsPrimary - 1
			} else if (parseInt(this.setAsPrimary) === parseInt(index)) {
				this.setAsPrimary = 0
				isPrimaryImageDeleted = true
			}

			const isNewImage = !image.id //Newly added image
			if (!isNewImage) {
				this.deletedImages.push(image)
				this.copiedImages = this.imageSrc.filter((dt) => dt.id)
				this.copiedPublishImages = this.imageSrc.filter((dt) => dt.id)

				if (isPrimaryImageDeleted) {
					if (this.imageSrc.length === 0) {
						this.updatedImages = []
						return
					}
					this.updatedImages = []
					this.updatedImages.push({ ...this.imageSrc[0], primary: true })
					if (this.copiedImages.length > 0) {
						this.copiedImages[0].primary = true
					} else if (this.copiedPublishImages.length > 0) {
						this.copiedPublishImages[0].primary = true
					} else {
						this.imageRef[0].primary = true
					}
				}
			} else {
				this.imageRef.splice(index, 1)
				this.filesToSend.splice(index, 1)
			}
		},

		setPrimaryPhoto(index, image) {
			const isNewImage = !image.id //Newly added image
			if (isNewImage) {
				if (this.isNewForm && !this.isDuplicate) {
					//New form
					let imageRefIdx = index
					if (this.copiedPublishImages.length > 0) {
						this.resetPrimaryPhoto("copiedPublishImages")
						const ctr = this.imageSrc.length - index
						imageRefIdx = this.imageRef.length - ctr
					}
					this.resetPrimaryPhoto("imageRef")
					this.imageRef[imageRefIdx].primary = true
					this.updatedImages = []
				} else if (this.isNewForm && this.isDuplicate) {
					const ctr = this.imageSrc.length - index
					const imageRefIdx = this.imageRef.length - ctr
					this.resetPrimaryPhoto("imageRef")
					this.imageRef[imageRefIdx].primary = true
					this.resetPrimaryPhoto("copiedImages")
					this.resetPrimaryPhoto("copiedPublishImages")
				} else {
					//Update form
					const ctr = this.imageSrc.length - index
					const imageRefIdx = this.imageRef.length - ctr

					this.resetPrimaryPhoto("imageRef")
					this.imageRef[imageRefIdx].primary = true
					this.updatedImages = []
				}
			} else {
				//Check if the form is a duplicate copy
				if (!this.isDuplicate) {
					if (this.copiedPublishImages.length > 0) {
						this.resetPrimaryPhoto("imageRef")
						this.resetPrimaryPhoto("copiedImages")
						this.resetPrimaryPhoto("copiedPublishImages")
						this.copiedPublishImages[index].primary = true
					} else if (this.updatedImages.length === 0) {
						//Reset all newly added images to primary false
						this.resetPrimaryPhoto("imageRef")

						//Insert the new primary photo to updatedImages
						this.updatedImages.push({ ...this.imageSrc[index], primary: true })
					} else {
						//Reset all newly added images to primary false
						this.resetPrimaryPhoto("imageRef")

						this.updatedImages = []
						//Insert the new primary photo to updatedImages
						this.updatedImages.push({ ...this.imageSrc[index], primary: true })
					}
				} else {
					this.resetPrimaryPhoto("imageRef")
					this.resetPrimaryPhoto("copiedImages")
					this.resetPrimaryPhoto("copiedPublishImages")
					this.copiedImages[index].primary = true
					this.copiedPublishImages[index].primary = true
				}
			}
		},

		//Reset primary photo of newly added images and previous images
		resetPrimaryPhoto(images) {
			if (this[images].length != 0) {
				this[images] = this[images].map((img) => {
					return {
						...img,
						primary: false,
					}
				})
			}
		},
		mobileFormat(mobileNumber) {
			if (mobileNumber) {
				let data = mobileNumber.split("")
				data.splice(4, 0, "-")
				return data.join("")
			} else {
				return ""
			}
		},

		async updatePuppyDetails() {
			this.isAPILoading = true
			try {
				this.isAPILoading = true

				const details = {
					formData: {
						id: this.puppySellId,
						breedId: this.breedId,
						microchipNumber: this.microchipNumber,
						price: this.price,
						priceStatus: this.priceStatus,
						birthdate: this.birthdate,
						gender: this.gender,
						colour: this.colour,
						headline: this.headline,
						body: this.body,
						puppyName: this.puppyName,
						status: this.status,
						imageRef: this.imageRef, //Image reference of the newly added photo
						updatedImages: this.updatedImages, //New primary photo
						deletedImages: this.deletedImages, //Images to be deleted in the database
					},
					images: this.filesToSend.length ? this.filesToSend : [],
				}

				const response = await puppySellService.updateUserPuppyDetails(details)

				if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
					this.showCustomSuccessToast(null, `Puppy details has been successfully updated!`)

					this.isAPILoading = false
					this.imageRef = []
					this.imageSrc = []
					this.fileBlob = null
					this.filesToSend = []
					this.setAsPrimary = 0
					this.updatedImages = []
					this.deletedImages = []

					if (this.isNewPuppyImage) {
						this.isPuppyImageLoading = true
						setTimeout(() => {
							this.getPuppyDetails(this.$route.query.id)
						}, 3000)
					} else {
						this.getPuppyDetails(this.$route.query.id)
					}
				} else {
					this.showAPIErrorToast("Unable to update puppy sell details.", response)
					this.isAPILoading = false
					await this.getPuppyDetails(this.$route.query.id)
				}
			} catch (err) {
				// Catch any error
				this.showGenericErrorToast()
				this.isAPILoading = false
			}
		},

		async reapprovedPuppyDetails() {
			this.isAPILoading = true
			try {
				this.isAPILoading = true

				const details = {
					formData: {
						id: this.puppySellId,
						breedId: this.breedId,
						microchipNumber: this.microchipNumber,
						price: this.price,
						priceStatus: this.priceStatus,
						birthdate: this.birthdate,
						gender: this.gender,
						colour: this.colour,
						headline: this.headline,
						body: this.body,
						status: "P",
						imageRef: this.imageRef, //Image reference of the newly added photo
						updatedImages: this.updatedImages, //New primary photo
						deletedImages: this.deletedImages, //Images to be deleted in the database
					},
					images: this.filesToSend.length ? this.filesToSend : [],
				}

				const response = await puppySellService.reapprovedPuppyDetails(details)

				if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
					this.showCustomSuccessToast(null, `Puppy details has been successfully sent for re-approval!`)
					this.isAPILoading = false
					this.$router.push(`${BREEDER_ROUTES.PUPPY_SALES}`);
				} else {
					this.showAPIErrorToast("Unable to send puppy sell details for re-approval.", response)
					this.isAPILoading = false
				}
			} catch (err) {
				// Catch any error
				this.showGenericErrorToast()
				this.isAPILoading = false
			}
		},

		deletePuppyToSell() {
			this.$refs.modalDeletePuppyToSell.openModal()
		},

		showEmail(email) {
			if (email) {
				window.location.href = `mailto:${email}`
			}
		},
		makeCopy() {
			this.$router.push(`${BREEDER_ROUTES.SELL_YOUR_PUPPY_INFO}?id=${this.puppySellId}&copy=true`)
		},
		async updatePuppySellStatus(puppySellId, status) {

			let htmlContent = `<p style='color: #ff801e; margin: .75rem 0 .25rem 0;'>Are you sure you want to update the puppy status to <strong style='color: #ff801e'>${PUPPY_SELL_STATUS[status]}</strong>?</p>`
			let titleContent = `Mark Puppy as ${PUPPY_SELL_STATUS[status]}`
			if (PUPPY_SELL_STATUS[status] === 'AVAILABLE') {
				titleContent =  `Update Puppy Status`
				htmlContent =  `<p style='color: #ff801e; margin: .75rem 0 .25rem 0;'>This puppy will be displayed on the "Find a Puppy" page. Are you sure you want to <strong style='color: #ff801e'>UNHIDE</strong>?</p>`
			}

			try {
				const modalConfirmationRes = await this.$swal({
					titleText: titleContent,
					html: htmlContent,
					confirmButtonText: "Confirm",
					showCancelButton: true,
					cancelButtonText: "Cancel",
					reverseButtons: true,
				});

				if (modalConfirmationRes.isConfirmed) {
					this.isAPILoading = true;

					const details = {
						// buyerId: this.buyerDetails.userId,
						status
					};
			
					const response = await puppySellService.updatePuppyDetailsStatus(puppySellId, details);
					
					if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						await this.getPuppyDetails(this.$route.query.id);
						let toastMsg = `Successfully updated Puppy selling status to ${PUPPY_SELL_STATUS[status]}`
						if (PUPPY_SELL_STATUS[status] === 'AVAILABLE') {
							toastMsg =  `Breeder has successfully unhid the puppy for viewing.`
						}
						this.showCustomSuccessToast(
							toastMsg
						);
					} else {
						const errorMessage = response.data.errors[0].message;

						if(response.status === STATUS_CODES.BAD_REQUEST){
							this.showAPIErrorToast(errorMessage, response);
						}
						else{
							this.showGenericErrorToast();
						}
					}
					this.isAPILoading = false;
				}
			} catch (err) {
				this.showGenericErrorToast();
			}
		},
		
		contactUsEmail() {
			window.location.href = "mailto:services@lovemydogclub.com.au";
		},
	},

	validations() {
		return this.validationRules
	},
}
